import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/AppWrapper.tsx");
